import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export class RoutingModalContext {
  public message: string;
  public title: string;
  public hasCloseLink?: boolean;
  public yesButtonText?: string;
  public noButtonText?: string;
  public skipButtonText?: string;
  public yesButtonLink?: string;
  public noButtonLink?: string;
  public skipButtonLink?: string;
  public customClass?: string;
}

@Component({
  selector: 'app-routing-modal',
  templateUrl: './routing-modal.component.html'
})
export class RoutingModalComponent {
  public context: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialogRef<RoutingModalContext>
  ) {
    this.context = data;
  }

  public goToFirstPage(): void {
    this.beforeDismiss();
    this.dialog.close('check-phone');
  }

  public goToSecondPage(): void {
    this.beforeDismiss();
    this.dialog.close('shop-phone');
  }

  public goToThirdPage(): void {
    this.beforeDismiss();
    this.dialog.close('skip');
  }

  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }

  beforeDismiss(): boolean {
    return this.beforeClose();
  }

  closeDialog(): void {
    this.beforeDismiss();
    this.dialog.close();
  }

  OK(): void {
    this.beforeDismiss();
    this.dialog.close(true);
  }
}

